import './ProjectStatsSections.scss';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { ReactElement, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from '../../../../__legacy__/components/Loader';
import { WorkspaceTimeZoneUpdatedEventType } from '../../../../__legacy__/modules/workspaces/sub/UpdateWorkspaceTimeZone/events/WorkspaceTimeZoneUpdatedEvent';
import { EventListeningDisposer, IEventBus } from '../../../../__legacy__/services/eventBus.service';
import { TimePeriod } from '../../../../design/selects/timePeriodSelector/S_TimePeriodSelector';
import { ColumnLayout } from '../../../common/layouts/columnLayout/ColumnLayout';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { AnnotationToolsSectionContainer } from './annotationTools/AnnotationToolsSection.container';
import { IProjectStatsFiltersBl } from './filters/ProjectStatsFilters.bl';
import { GeneralSectionContainer } from './general/GeneralSection.container';
import { IProjectStatsBl } from './ProjectStats.bl';
import { IProjectStatsStore } from './ProjectStats.store';
import { ProjectStatsTopBar } from './ProjectStatsTopBar';
import { WorkPerformanceSectionContainer } from './workPerformance/WorkPerformanceSection.container';

export const ProjectStatsSectionsContainer = observer((): ReactElement => {
  const bl = useInjection(IProjectStatsBl.$);
  const store = useInjection(IProjectStatsStore.$);
  const filtersBl = useInjection(IProjectStatsFiltersBl.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const eventBus = useInjection(IEventBus.$);

  const workspaceTimeZoneUpdatedDisposer = useRef<EventListeningDisposer>(null);
  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    workspaceTimeZoneUpdatedDisposer.current = eventBus.addListener(handleWorkspaceTimeZoneUpdated, WorkspaceTimeZoneUpdatedEventType);

    void loadAsync();
    return (): void => workspaceTimeZoneUpdatedDisposer.current?.();
  }, []);

  const handleWorkspaceTimeZoneUpdated = async (): Promise<void> => {
    await loadAsync();
  };

  const loadAsync = async (): Promise<void> => {
    const statsStartDate = moment(currentWorkspaceStore.currentWorkspaceTime).startOf('month').utcOffset(0, true);
    const statsEndDate = moment(currentWorkspaceStore.currentWorkspaceTime).endOf('month').utcOffset(0, true);

    await bl.displayStatsAsync(projectId, TimePeriod.Month, statsStartDate, statsEndDate);

    filtersBl.load(
      projectId,
      store.generalStats.map((gs) => ({ id: gs.id, email: gs.email })),
      statsStartDate,
      statsEndDate
    );
  };

  return (
    <div className='project-stats-sections-container'>
      <Loader isLoading={store.isLoading}>
        <ColumnLayout size='sm'>
          <ProjectStatsTopBar />
          <div>
            <GeneralSectionContainer />
            <AnnotationToolsSectionContainer />
            <WorkPerformanceSectionContainer />
          </div>
        </ColumnLayout>
      </Loader>
    </div>
  );
});
